import moment from 'moment';
import { getIPInfo } from '../api/api';

/* Check if Table and desktop */
export const desktopDesign = () => {
  if (
    window.deviceType &&
    (window.deviceType.isTablet || !window.deviceType.isMobile)
  ) {
    return true;
  }
  return false;
};

/* Check if only Desktop */
export const onlyDesktopDesign = () => {
  if (
    window.deviceType &&
    !window.deviceType.isTablet &&
    !window.deviceType.isMobile
  ) {
    return true;
  }
  return false;
};

/* Check if only mobile */
export const mobileDesign = () => {
  if (
    window.deviceType &&
    window.deviceType.isMobile &&
    !window.deviceType.isTablet
  ) {
    return true;
  }
  return false;
};

/* Extract UTMs from URL to their own properties */

export const extractUTM = () => {
  if (window.location.search && window.location.search.length > 0) {
    const utmArray = window.location.search
      .substring(window.location.search.indexOf('?') + 1)
      .split('&');

    const utms = {
      utm_campaign: 'bolivar',
    };

    utmArray.forEach((utm) => {
      const [key, value] = utm.split('=');
      if (key === 'utm_campaign') {
        utms.utm_campaign = value;
      }
      if (key === 'utm_source') {
        utms.utm_source = value;
      }
      if (key === 'utm_medium') {
        utms.utm_medium = value;
      }
      if (key === 'utm_term') {
        utms.utm_term = value;
      }
    });

    return utms;
  }
};

/**
 * This function return a new query string from the current URL or a custom url
 * passed as parameter with the keys passed in {paramsToGet}
 * @param {Array} paramsToGet the shape of the array must be as follows
 *  [{
 *    @param {String} key: '', key param you want to get
 *    @param {Boolean} replaceValue: false,
 *    @param {String} valueToReplace: '', String value you that want to replace with
 *  }]
 * @param {String} URLString work with a different URL, not with current
 */
export const getURLStringParams = (
  paramsToGet,
  URLString = window.location.search,
) =>
  URLString.substring(1)
    .split('&')
    .map((param) => {
      const [key, value] = param.split('=');
      const keyToFilter = paramsToGet.find(
        (paramToFilter) => paramToFilter.key === key,
      );
      if (keyToFilter) {
        return {
          [key]: keyToFilter.replaceValue ? keyToFilter.valueToReplace : value,
        };
      }
      return false;
    })
    .filter((value) => !!value)
    .map(
      (obj) => Object.entries(obj).map(([key, value]) => `${key}=${value}`)[0],
    )
    .join('&');

export const isValidIPV4Address = (IPAddress) =>
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
    IPAddress,
  );

export const isValidIPV6Address = (IPAddress) =>
  /^((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4}))*::((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4}))*|((?:[0-9A-Fa-f]{1,4}))((?::[0-9A-Fa-f]{1,4})){7}$/.test(
    IPAddress,
  );

export const isIPFromIndeed = async () => {
  const { ip } = await getIPInfo(window.activeEnvironment || 'staging');
  const IPsToFilter = window.IpsFromIndeed || '';
  const IPs = IPsToFilter.split(',').filter(
    (_) => isValidIPV4Address(_) || isValidIPV6Address(_),
  );
  return {
    result: IPs.includes(ip),
    evaluatedIp: ip,
  };
};

export const fixUploadedFileDate = (dateString) => {
  const formatDate = moment(dateString).isValid()
    ? moment(dateString)
    : moment();
  return formatDate.utc().toISOString();
};

const applyInlineFormatting = (text) =>
  text
    .replace(/\*\*\*(.+?)\*\*\*/g, '<strong><em>$1</em></strong>')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/__(.+?)__/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/_(.+?)_/g, '<em>$1</em>');

const parseMarkdown = (content) => {
  const lines = content.split('\n');
  const result = [];
  let i = 0;

  while (i < lines.length) {
    const line = lines[i];

    if (/^[-*+] /.test(line)) {
      const items = [];
      while (i < lines.length && /^[-*+] /.test(lines[i])) {
        items.push(`<li>${applyInlineFormatting(lines[i].replace(/^[-*+] /, ''))}</li>`);
        i++;
      }
      result.push(`<ul>${items.join('')}</ul>`);
      continue;
    }

    if (/^\d+\. /.test(line)) {
      const items = [];
      while (i < lines.length && /^\d+\. /.test(lines[i])) {
        items.push(`<li>${applyInlineFormatting(lines[i].replace(/^\d+\. /, ''))}</li>`);
        i++;
      }
      result.push(`<ol>${items.join('')}</ol>`);
      continue;
    }

    if (/^### /.test(line)) {
      result.push(`<h3>${applyInlineFormatting(line.slice(4))}</h3>`);
    } else if (/^## /.test(line)) {
      result.push(`<h2>${applyInlineFormatting(line.slice(3))}</h2>`);
    } else if (/^# /.test(line)) {
      result.push(`<h1>${applyInlineFormatting(line.slice(2))}</h1>`);
    } else if (line.trim() !== '') {
      result.push(`<p>${applyInlineFormatting(line)}</p>`);
    }

    i++;
  }

  return result.join('');
};

/* Detect whether content is HTML or markdown and return safe HTML string */
export const renderJobDescription = (content) => {
  if (!content) return '';
  const isHtml = /<[a-z][\s\S]*>/i.test(content);
  return isHtml ? content : parseMarkdown(content);
};

/* Normalize job type for translation lookup */
export const normalizeJobType = (jobType) => {
  if (!jobType || typeof jobType !== 'string') return '';

  // Convert camelCase/PascalCase to space-separated format
  // "FullTime" -> "Full Time", "PartTime" -> "Part Time", "Both" -> "Both"
  // If already spaced, return as-is to avoid double spaces
  if (jobType.includes(' ')) {
    return jobType;
  }

  return jobType
    .replace(/([A-Z])/g, ' $1') // Add space before capital letters
    .trim(); // Remove any leading space
};
